import { useCallback } from 'react';
import { updateConversation } from 'services/api/conversation.convList';
import { useMakeConversationCache } from 'hooks/business/conversation';

/** 执行已读操作, 在`点击会话标签`或`当前服务的会话接收消息`时执行, `会话标签`不显示`机器人,转发,超管回复`等标记, 未读数为0 */
export function useConversationRead() {
  const setConversation = useMakeConversationCache('set');

  return useCallback(
    async (item: Conversation.Conversation) => {
      setConversation({
        ...item,
        unreadCount: 0,
        transferMark: false,
        botMark: false,
        superviseMark: false,
      });
      if (!item.talkId) {
        // 此接口名为updateConversation，但其实更新的是talk
        // 从来没接待过，并且没有抢到控制权会导致没有talkId， 没有talkId就没必要去更新talk了
        return;
      }
      const { talkId, assistantId, controlStatus } = item;

      await updateConversation({
        userId: assistantId,
        talkId: [talkId],
        read: controlStatus ? '1' : undefined,
        clearMark: true,
      });
    },
    [setConversation],
  );
}
